import { Box, Button } from "@mui/material";
import { API_URL, BootstrapTooltip } from "../../utilities";
import PageTitle from "../../components/PageTitle";
import DeleteIcon from "@mui/icons-material/Delete";
import PreviewIcon from "@mui/icons-material/Preview";
import {
  GridActionsCellItem,
  GridColDef,
  GridRenderCellParams,
  GridRowId,
  GridRowModesModel,
  GridToolbarContainer,
} from "@mui/x-data-grid";
import moment from "jalali-moment";
import GridViewMUIX from "../../components/GridViewMUIX";
import { useMutation, useQuery } from "@tanstack/react-query";
import { useAuth } from "../../context/auth";
import { MouseEvent, useEffect, useState } from "react";
import { useNotifications } from "@toolpad/core/useNotifications";
import AddIcon from "@mui/icons-material/Add";
import PopoverComponent from "../../components/PopoverComponent";
import NewBase from "./new-base";
import SkeltonProgress from "../../components/SkeltonProgress";
import { getRoutes } from "src/utilities/routes";
const BaseAgreements = () => {
  const notifications = useNotifications();
  const { user } = useAuth();
  const { isLoading, error, data, refetch } = useQuery({
    queryKey: ["MainBaseAgreementsData"],
    queryFn: () =>
      fetch(API_URL + "base-agreements", {
        method: "GET",
        headers: {
          Authorization: `Bearer ${user?.token}`,
          Aceept: "application/json",
        },
      }).then((res) => res.json()),
  });

  const [rows, setRows] = useState<any>();
  const [openTask, setOpenTask] = useState<boolean>(false);

  useEffect(() => {
    if (error) {
      notifications.show("خطا در دریافت اطلاعات" + error.toString(), {
        severity: "error",
        autoHideDuration: 3000,
      });
      console.log(error);
    }
  }, [error]);

  useEffect(() => {
    data && setRows(data);
  }, [data, user?.token]);
  const [rowModesModel, setRowModesModel] = useState<GridRowModesModel>({});

  const columns: GridColDef[] = [
    {
      field: "actions",
      type: "actions",
      headerAlign: "center",
      headerName: "عملیات",
      align: "center",
      sortable: false,
      disableColumnMenu: true,
      cellClassName: "actions",
      minWidth: 150,
      getActions: (params) => {
        return [
          <BootstrapTooltip title="نمایش و ویرایش">
            <GridActionsCellItem
              icon={<PreviewIcon color="primary" />}
              label="نمایش و ویرایش"
              className="textPrimary"
              onClick={handleEditClick(params.id)}
              color="inherit"
            />
          </BootstrapTooltip>,
          <BootstrapTooltip title="حذف">
            <GridActionsCellItem
              icon={<DeleteIcon color="error" />}
              label="حذف"
              onClick={(event) => handleDeleteClick(event, params.id)}
              color="inherit"
            />
          </BootstrapTooltip>,
        ];
      },
    },
    {
      field: "name",
      headerName: "سال",
      align: "left",
      headerAlign: "left",
      editable: true,
      sortable: true,
      minWidth: 200,
    },
    {
      field: "isActive",
      headerName: "فعال",
      align: "center",
      headerAlign: "center",
      editable: false,
      sortable: true,
      type: "boolean",
      minWidth: 100,
      renderCell: (params: GridRenderCellParams<any, boolean>) => (
        <Box
          sx={{
            backgroundColor: params.value ? "success.main" : "grey.300",
            color: params.value ? "white" : "text.primary",
            padding: "4px 8px",
            borderRadius: "4px",
            fontSize: "0.75rem",
            fontWeight: "bold",
          }}
        >
          {params.value ? "فعال" : "غیرفعال"}
        </Box>
      ),
    },
    {
      field: "createdOn",
      headerName: "تاریخ ایجاد",
      align: "left",
      headerAlign: "left",
      editable: true,
      sortable: true,
      renderCell: (params: GridRenderCellParams<any, string>) =>
        `${
          params.value &&
          moment.from(params.value, "en", "YYYY-MM-DD").format("jYYYY/jMM/jDD")
        }`,
      minWidth: 180,
    },
    {
      field: "modifiedOn",
      headerName: "تاریخ ویرایش",
      align: "center",
      headerAlign: "center",
      editable: true,
      sortable: true,
      renderCell: (params: GridRenderCellParams<any, string>) =>
        `${
          params.value &&
          moment.from(params.value, "en", "YYYY-MM-DD").format("jYYYY/jMM/jDD")
        }`,
      minWidth: 180,
    },
  ];

  // const { mutateAsync: updateAsync, isPending: isEditLoading } = useMutation({
  //   mutationFn: async (body: any) => {
  //     const response = await fetch(API_URL + "services/" + body.id, {
  //       method: "PUT",
  //       headers: {
  //         Accept: "*/*",
  //         "Content-Type": "application/json-patch+json",
  //         Authorization: `Bearer ${user?.token}`,
  //       },
  //       body: JSON.stringify(body),
  //     });
  //     return await response.json();
  //   },
  //   onSuccess: (responseData) => {
  //     JSON.stringify(responseData);
  //   },
  //   onError: (error) => {
  //     notifications.show("خطا در دریافت اطلاعات", {
  //       severity: "error",
  //       autoHideDuration: 3000,
  //     });
  //     console.log("eee", error);
  //   },
  // });
  const Routes = getRoutes();
  const { mutateAsync: deleteAsync, isPending: isDeleteLoading } = useMutation({
    mutationFn: async () => {
      const response = await fetch(
        Routes.BaseAgreementsRoutes + baseAgreementId,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${user?.token}`,
            Aceept: "application/json",
          },
        }
      );
      console.log(response);

      return await response.json();
    },
    onSuccess: (responseData) => {
      JSON.stringify(responseData);
    },
    onError: (error) => {
      notifications.show("خطا در دریافت اطلاعات", {
        severity: "error",
        autoHideDuration: 3000,
      });
      console.log(error);
    },
  });

  const [baseAgreementId, setBaseAgreementId] = useState<number>();

  const [anchorDeleteEl, setAnchorDeleteEl] =
    useState<HTMLButtonElement | null>(null);
  const openDeletePopover = Boolean(anchorDeleteEl);
  const idDeletePopover = openDeletePopover ? "simple-popover" : undefined;
  const handleDeleteClick = (
    event: MouseEvent<HTMLButtonElement>,
    id: GridRowId
  ) => {
    setAnchorDeleteEl(event.currentTarget);
    setBaseAgreementId(id as number);
  };
  const handleDeletePopoverClose = () => {
    setAnchorDeleteEl(null);
  };
  const handleDelete = async () => {
    try {
      const res = await deleteAsync();
      if (res.status) {
        notifications.show("حذف با موفقیت انجام شد!", {
          severity: "success",
          autoHideDuration: 5000,
        });
      } else {
        notifications.show("خطا در حذف!", {
          severity: "error",
          autoHideDuration: 5000,
        });
      }
    } catch (error) {
      console.log("🚀 ~ handleDelete ~ error:", error);
      notifications.show("خطا در حذف!", {
        severity: "error",
        autoHideDuration: 5000,
      });
    } finally {
      refetch();
      handleDeletePopoverClose();
      setBaseAgreementId(undefined);
    }
  };

  function EditToolbar() {
    return (
      <GridToolbarContainer>
        <Button
          color="primary"
          startIcon={<AddIcon />}
          onClick={() => setOpenTask(true)}
        >
          پایه قرار داد جدید
        </Button>
      </GridToolbarContainer>
    );
  }
  const handleEditClick = (id: GridRowId) => () => {
    setBaseAgreementId(id as number);
    setOpenTask(true);
  };

  const handleClose = () => {
    setOpenTask(false);
  };

  return (
    <>
      <PageTitle title="پایه قرارداد" />
      <PopoverComponent
        caption=" حذف انجام شود؟"
        anchorEl={anchorDeleteEl}
        handlePopoverClose={handleDeletePopoverClose}
        handler={handleDelete}
        id={idDeletePopover}
        isLoading={isDeleteLoading}
        open={openDeletePopover}
        key={"delete"}
      />

      <NewBase
        open={openTask}
        handleClose={handleClose}
        isEdit={!!baseAgreementId}
        serviceId={baseAgreementId}
        setServiceId={setBaseAgreementId}
        refetch={refetch}
        // data={rowInfo}
      />

      <Box
        sx={{
          width: {
            xs: 370, // عرض برای اندازه‌های کوچک
            sm: 500, // عرض برای اندازه‌های متوسط
            md: 720, // عرض برای اندازه‌های بزرگ
            lg: "calc(100% - 80px)", // عرض برای اندازه‌های خیلی بزرگ
            xl: "calc(100% - 80px)", // عرض برای اندازه‌های فوق‌العاده بزرگ
          },
        }}
      >
        {isLoading ? (
          <SkeltonProgress />
        ) : (
          <GridViewMUIX
            gridUniqueName="Services"
            columns={columns}
            loading={isLoading}
            EditToolbar={EditToolbar}
            rowModesModel={rowModesModel}
            sortFields={{ field: "modifiedOn", sort: "desc" }}
            rows={rows}
            setRowModesModel={setRowModesModel}
          />
        )}
      </Box>
    </>
  );
};

export default BaseAgreements;
